<div class="container term-of-services-container">
  <header class="header">
    <button class="back-button" (click)="goBack()">
      <span class="back-arrow">←</span>
    </button>
    <div class="d-flex flex-column">
      <h1 class="header-text">Terms of Service, Acceptable Use Policy (AUP) & End User License Agreement (EULA)</h1>
      <h5 class="header-subtitle m-0">IMPORTANT: PLEASE READ CAREFULLY</h5>
    </div>
  </header>

  <div class="content">
    <p class="last-updated">Last Updated: {{ lastUpdated }}</p>

    <section class="section">
      <p class="paragraph">
        <b>By downloading, installing, accessing, or using Adore The Balloon ("the App", "the Service"), you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions and End User License Agreement (EULA). If you do not agree to these terms, you must immediately discontinue use of the App and delete it from your device.</b>
      </p>

      <p class="paragraph">
       <b> YOU MUST EXPRESSLY AGREE TO THESE TERMS BEFORE USING THE APP. YOUR USE OF THE APP CONSTITUTES YOUR ACCEPTANCE OF THESE TERMS.</b>
      </p>
    </section>
    <section class="section">
      <h2 class="heading">1. END USER LICENSE AGREEMENT (EULA)</h2>
      <h3 class="sub-heading">1.1 License Grant</h3>
      <p class="paragraph">
        Subject to your compliance with these Terms, Adore The Balloon grants you a limited, non-exclusive, non-transferable, revocable license to access and use the App on your personal device for personal, non-commercial purposes only.
      </p>
      
      <h3 class="sub-heading">1.2 License Restrictions</h3>
      <p class="paragraph">You may NOT:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Copy, modify, distribute, sell, or lease any part of the App</li>
        <li class="bullet-point">Reverse engineer, decompile, or disassemble the App</li>
        <li class="bullet-point">Remove any proprietary notices or labels</li>
        <li class="bullet-point">Use the App for any illegal or unauthorized purpose</li>
        <li class="bullet-point">Transfer or sublicense your rights under this license</li>
      </ul>
      
      <h3 class="sub-heading">1.3 Termination of License</h3>
      <p class="paragraph">This license is effective until terminated. We may terminate your license immediately, without prior notice, if you breach these Terms. Upon termination, you must immediately cease all use of the App and delete it from your device.</p>
    
    </section>

    <section class="section">
      <h2 class="heading">2. ACCEPTANCE OF TERMS AND USER AGREEMENT</h2>
      <p class="paragraph"><b>By creating an account, accessing, or using Adore The Balloon, you represent and warrant that:</b></p>
      
      <ul class="bullet-list">
        <li class="bullet-point">You have read and understood these Terms and Conditions in their entirety</li>
        <li class="bullet-point">You agree to be legally bound by these Terms</li>
        <li class="bullet-point">You will comply with all applicable laws and regulations</li>
        <li class="bullet-point">You are at least 18 years of age and have the legal capacity to enter into this agreement</li>
        <li class="bullet-point">You understand that violation of these Terms may result in immediate account termination and legal action</li>
      </ul>
      
      <p class="paragraph"><b>If you do not agree to any part of these Terms, you must not use the App.</b></p>
    </section>
    
    <section class="section">
      <h2 class="heading">3. ZERO TOLERANCE POLICY FOR OBJECTIONABLE CONTENT AND ABUSIVE USERS</h2>
      
      <h3 class="sub-heading">3.1 Zero Tolerance Statement</h3>
      <p class="paragraph">Adore The Balloon maintains an absolute ZERO TOLERANCE policy for objectionable content, abusive users, human trafficking, sexual violence, and exploitation. We are uncompromisingly committed to providing a safe, respectful, and lawful environment for all users.</p>
      
      <h3 class="sub-heading">3.2 Prohibited Content</h3>
      <p class="paragraph"><b>You are STRICTLY PROHIBITED from posting, sharing, transmitting, or displaying any of the following objectionable content:</b></p>
      <ul class="bullet-list">
        <li class="bullet-point"><b>Human Trafficking and Sexual Exploitation:</b> Any content that promotes, facilitates, coordinates, advertises, or depicts human trafficking, sex trafficking, involuntary servitude, or sexual exploitation of any person. We report all instances of human trafficking to law enforcement immediately.</li>
        <li class="bullet-point"><b>Sexually Explicit Content and Solicitation:</b> Nudity, pornography, sexually suggestive or graphic imagery, or any content of a sexual nature. Prohibitions on sexually explicit content and sexual solicitation are NOT limited strictly to unsolicited or non-consensual interactions; all sexually explicit conduct, commercial sex, prostitution, escort services, cybersex, and sexually driven transactional interactions are strictly prohibited regardless of mutual consent.</li>
        <li class="bullet-point"><b>Non-Consensual Intimate Imagery (NCII) and Revenge Porn:</b> Uploading, transmitting, sharing, displaying, possessing, or threatening to share nude, sexually explicit, or private intimate images or videos of any person without their explicit affirmative consent.</li>
        <li class="bullet-point"><b>Sexual Violence and Physical Harm:</b> Content depicting, promoting, or glorifying sexual violence, sexual assault, rape, non-consensual sexual contact, physical violence, or threats of harm against any person.</li>
        <li class="bullet-point"><b>Aiding, Abetting, or Facilitating Abuse:</b> Any content intended to assist, aid, abet, encourage, coordinate, or facilitate the abuse, exploitation, stalking, harassment, or harm of any person.</li>
        <li class="bullet-point"><b>Hate Speech:</b> Content that promotes hatred, discrimination, or violence based on race, ethnicity, religion, gender, sexual orientation, disability, or any other protected characteristic</li>
        <li class="bullet-point"><b>Harassment or Bullying:</b> Content intended to harass, intimidate, bully, or harm other users</li>
        <li class="bullet-point"><b>Illegal Activities:</b> Content promoting or depicting illegal activities, including but not limited to drug use, weapons, or criminal behavior</li>
        <li class="bullet-point"><b>Spam or Fraud:</b> Misleading, fraudulent, or spam content designed to deceive or defraud users</li>
        <li class="bullet-point"><b>Personal Information & Doxxing:</b> Sharing private, identifying, or confidential information of others without consent</li>
        <li class="bullet-point"><b>Fake Profiles:</b> Creating fake accounts, impersonating others, or using false information</li>
        <li class="bullet-point"><b>Child Exploitation:</b> Any content involving minors or child exploitation (we will report such content to law enforcement and NCMEC immediately)</li>
      </ul>

      <h3 class="sub-heading">3.3 Prohibited User Behavior</h3>
      <p>The following abusive behaviors are STRICTLY PROHIBITED and will result in immediate account termination, permanent ban, and referral to law enforcement:</p>
      <ul class="bullet-list">
        <li class="bullet-point"><b>Human Trafficking & Sex Trafficking:</b> Engaging in, organizing, advertising, facilitating, encouraging, or aiding human trafficking, sex trafficking, or commercial sexual exploitation in any form.</li>
        <li class="bullet-point"><b>Sexual Violence (Standalone Category):</b> Engaging in, attempting, or threatening sexual violence, sexual assault, sexual coercion, non-consensual sexual touching, rape, or any sexually abusive acts. Sexual violence is strictly treated as a distinct, standalone category of severe prohibited behavior.</li>
        <li class="bullet-point"><b>Aiding, Abetting, and Facilitating Harm:</b> Aiding, abetting, encouraging, assisting, or facilitating the abuse, sexual violence, exploitation, harassment, or harm of any person. Individuals who assist or facilitate harm against others face the same severe enforcement as primary offenders.</li>
        <li class="bullet-point"><b>Sexually Driven and Transactional Interactions:</b> Engaging in or soliciting sexually driven interactions, prostitution, escort services, commercial sex, or transactional arrangements (including 'sugar dating' or exchanging financial compensation, gifts, or favors for sexual acts or companionship), regardless of whether such interaction is initiated consensually.</li>
        <li class="bullet-point"><b>Non-Consensual Intimate Imagery (NCII) & Extortion:</b> Sharing, distributing, possessing, or threatening to share private sexual images or intimate recordings (revenge porn or sextortion) of another user or third party.</li>
        <li class="bullet-point"><b>Harassment & Stalking:</b> Repeatedly contacting, messaging, following, or tracking users who have expressed disinterest or asked you to cease contact.</li>
        <li class="bullet-point"><b>Threats & Intimidation:</b> Making threats of physical, sexual, emotional, or financial harm, or using coercion, extortion, or intimidation against others.</li>
        <li class="bullet-point"><b>Discrimination & Slurs:</b> Treating users unfairly or directing abusive language, slurs, profanity, or hate speech at others based on protected characteristics.</li>
        <li class="bullet-point"><b>Scamming & Fraud:</b> Attempting to defraud, scam, or financially exploit other users through false pretenses or investment schemes.</li>
        <li class="bullet-point"><b>Physical Violence:</b> Engaging in, attempting, or threatening physical assault or violence against other users.</li>
        <li class="bullet-point"><b>Doxxing:</b> Sharing private, residential, or contact information about other users without their express written consent.</li>
      </ul>

      <h3 class="sub-heading">3.4 Enforcement Actions</h3>
      <p>Violation of our Zero Tolerance Policy will result in:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Immediate account suspension or permanent termination</li>
        <li class="bullet-point">Permanent ban from the App and associated platforms</li>
        <li class="bullet-point">Reporting to law enforcement authorities and regulatory bodies when applicable</li>
        <li class="bullet-point">Legal action when necessary</li>
        <li class="bullet-point">No refunds for subscriptions, virtual items, or purchases</li>
      </ul>
      <p>We reserve the right to review, remove, or report any content or user behavior that violates these policies, even if not explicitly listed above.</p>

      <h3 class="sub-heading">3.5 Reporting Violations</h3>
      <p>If you encounter objectionable content, abusive behavior, trafficking, or sexual misconduct, you must:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Report it immediately using the in-app reporting feature</li>
        <li class="bullet-point">Block the user to prevent further contact</li>
        <li class="bullet-point">Contact our safety team at support@poptheballoon.com</li>
        <li class="bullet-point">In cases of immediate danger, sexual assault, or emergency, contact local emergency services immediately</li>
      </ul>
      <p>We take all reports seriously and investigate promptly. Reports are strictly confidential and anonymous to the reported user.</p>
    </section>

    <section class="section">
      <h2 class="heading">4. ELIGIBILITY REQUIREMENTS</h2>

      <h3 class="sub-heading">4.1 Age Requirement</h3>
      <p class="paragraph">You must be at least **18 years of age** to use Adore The Balloon. By creating an account, you represent and warrant that you are 18 years or older.</p>
      
      <h3 class="sub-heading">4.2 Legal Capacity</h3>
      <p class="paragraph">You must have the legal capacity to enter into binding agreements in your jurisdiction. If you are using the App on behalf of an organization, you must have authority to bind that organization to these Terms.</p>
      
      <h3 class="sub-heading">4.3 Relationship Status</h3>
      <p class="paragraph">You must be legally single and available to date. You may not use the App if you are married or in a committed relationship, unless you are in a legally recognized open relationship and have disclosed this to other users.</p>
      
      <h3 class="sub-heading">4.4 Verification Requirements</h3>
      <p>You must:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Provide accurate and truthful information during registration</li>
        <li class="bullet-point">Complete phone number verification</li>
        <li class="bullet-point">Complete email verification</li>
        <li class="bullet-point">Maintain accurate profile information</li>
        <li class="bullet-point">Use only one account per person</li>
      </ul>
      <p>Providing false information or creating multiple accounts will result in immediate account termination.</p>
    </section>
    
    <section class="section">
      <h2 class="heading">5. ACCOUNT REGISTRATION AND RESPONSIBILITIES</h2>
      
      <h3 class="sub-heading">5.1 Account Creation</h3>
      <p>To use Adore The Balloon, you must create an account by providing:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Valid email address</li>
        <li class="bullet-point">Valid phone number</li>
        <li class="bullet-point">Personal information (name, age, gender, location)</li>
        <li class="bullet-point">Profile photos (minimum required)</li>
        <li class="bullet-point">Bio and optional voice recording</li>
      </ul>
      
      <h3 class="sub-heading">5.2 Account Security</h3>
      <p>You are solely responsible for:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Maintaining the confidentiality of your account credentials</li>
        <li class="bullet-point">All activities that occur under your account</li>
        <li class="bullet-point">Notifying us immediately of any unauthorized access</li>
        <li class="bullet-point">Keeping your profile information accurate and up-to-date</li>
        <li class="bullet-point">Logging out of your account on shared devices</li>
      </ul>
      <p>Your account is personal to you and may not be shared, transferred, or sold to another person. You may not create accounts for others or allow others to use your account.</p>
      
      <h3 class="sub-heading">5.3 Account Ownership</h3>
      <p>You will be held liable for any activities that occur under your account, whether authorized by you or not.</p>
    </section>

    <section class="section">
      <h2 class="heading">6. USER CONDUCT AND PROHIBITED ACTIVITIES</h2>

      <h3 class="sub-heading">6.1 General Prohibitions</h3>
      <p>In addition to the Zero Tolerance Policy outlined in Section 3, you agree NOT to:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Post false, misleading, or fraudulent information</li>
        <li class="bullet-point">Use the App for commercial purposes, advertising, or spam</li>
        <li class="bullet-point">Engage in, coordinate, facilitate, or promote human trafficking, sex trafficking, or commercial sexual exploitation</li>
        <li class="bullet-point">Aid, abet, encourage, or facilitate the abuse, sexual violence, exploitation, or harm of any person</li>
        <li class="bullet-point">Engage in, solicit, or arrange sexually explicit interactions, commercial sexual arrangements, or transactional relationships, whether consensual or unsolicited</li>
        <li class="bullet-point">Distribute, record, share, or threaten to share non-consensual intimate imagery (NCII) or private sexual content</li>
        <li class="bullet-point">Impersonate another person, entity, or organization</li>
        <li class="bullet-point">Share your account credentials with others</li>
        <li class="bullet-point">Attempt to reverse engineer, hack, or compromise the App's security</li>
        <li class="bullet-point">Use automated systems, bots, or scripts to access the App</li>
        <li class="bullet-point">Interfere with or disrupt the App's servers or networks</li>
        <li class="bullet-point">Violate any applicable local, state, national, or international laws or regulations</li>
        <li class="bullet-point">Collect or harvest information about other users without consent</li>
        <li class="bullet-point">Use the App to promote other services, products, or websites</li>
      </ul>

      <h3 class="sub-heading">6.2 Content Standards</h3>
      <p>All content you post, including photos, bios, messages, and voice recordings, must:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Be accurate and truthful</li>
        <li class="bullet-point">Be your own original content (or you must have permission to use it)</li>
        <li class="bullet-point">Comply with all applicable laws</li>
        <li class="bullet-point">Respect the rights and dignity of others</li>
        <li class="bullet-point">Not infringe on intellectual property rights</li>
      </ul>

      <h3 class="sub-heading">6.3 Consequences of Violations</h3>
      <p>Violation of these conduct rules may result in:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Warning or temporary suspension</li>
        <li class="bullet-point">Permanent account termination</li>
        <li class="bullet-point">Legal action</li>
        <li class="bullet-point">Reporting to law enforcement</li>
        <li class="bullet-point">No refunds for subscriptions or purchases</li>
      </ul>
    </section>

    <section class="section">
      <h2 class="heading">7. ACCEPTABLE USE POLICY (AUP)</h2>
      <p class="paragraph">
        <b>This Acceptable Use Policy (AUP) sets forth the mandatory behavioral and content standards that strictly govern all users of Adore The Balloon. By accessing, downloading, or using the Service, you agree unconditionally to comply with this AUP. Violations of this policy will result in immediate account termination, permanent platform banning, and potential referral to law enforcement authorities.</b>
      </p>

      <h3 class="sub-heading">7.1 Prohibition of Human Trafficking and Sex Trafficking</h3>
      <p class="paragraph">Adore The Balloon strictly prohibits any use of the Service to facilitate, coordinate, advertise, or engage in human trafficking, sex trafficking, or involuntary labor. You may not:</p>
      <ul class="bullet-list">
        <li class="bullet-point"><strong>Trafficking Facilitation:</strong> Recruit, harbor, transport, provide, obtain, patronize, or solicit any person for commercial sex acts, prostitution, forced labor, or sexual exploitation.</li>
        <li class="bullet-point"><strong>Exploitation Networks:</strong> Use the Service to advertise, coordinate, organize, or facilitate sex trafficking operations or involuntary servitude.</li>
        <li class="bullet-point"><strong>Logistical Support:</strong> Provide assistance, communication channels, or advertising that furthers trafficking operations or the exploitation of vulnerable individuals.</li>
      </ul>

      <h3 class="sub-heading">7.2 Sexual Violence (Distinct Standalone Category)</h3>
      <p class="paragraph">Sexual violence is recognized and treated as a distinct, standalone category of prohibited behavior, strictly separate from general physical violence. Prohibited conduct includes:</p>
      <ul class="bullet-list">
        <li class="bullet-point"><strong>Sexual Assault:</strong> Any non-consensual sexual act, non-consensual physical contact of a sexual nature, or attempted sexual assault.</li>
        <li class="bullet-point"><strong>Sexual Coercion:</strong> Using threats, extortion, manipulation, physical force, or intoxication to compel, pressure, or coerce any person into sexual acts, conversations, or content sharing.</li>
        <li class="bullet-point"><strong>Sexually Abusive Conduct:</strong> Any pattern of behavior intended to sexually degrade, violate, intimidate, or abuse another individual.</li>
        <li class="bullet-point"><strong>Threats of Sexual Harm:</strong> Making explicit, implied, or conditional threats of sexual harm, assault, rape, or violation against any person.</li>
      </ul>

      <h3 class="sub-heading">7.3 Non-Consensual Intimate Imagery (NCII) and Revenge Porn</h3>
      <p class="paragraph">The creation, distribution, possession, or threat of dissemination of private sexual or intimate content without affirmative consent is strictly forbidden:</p>
      <ul class="bullet-list">
        <li class="bullet-point"><strong>Distribution of NCII:</strong> Uploading, sharing, transmitting, posting, or distributing nude, semi-nude, or sexually explicit photos, videos, or audio recordings of any individual without their explicit, verifiable affirmative consent.</li>
        <li class="bullet-point"><strong>Revenge Porn & Sextortion:</strong> Threatening to share, publish, or distribute intimate imagery or private sexual information to extort money, favors, sexual acts, or compliance from any person.</li>
        <li class="bullet-point"><strong>Non-Consensual Recording:</strong> Screen-recording, screenshotting, or surreptitiously capturing intimate content, video calls, or private messages of other users without their express permission.</li>
      </ul>

      <h3 class="sub-heading">7.4 Prohibition of Consensual Sexually Driven Interactions and Transactional Arrangements</h3>
      <p class="paragraph">Adore The Balloon is designed exclusively for genuine dating and relationship connections. To protect user safety and prevent commercial exploitation, our prohibitions against sexually driven interactions and solicitation are NOT limited to unsolicited or non-consensual messages:</p>
      <ul class="bullet-list">
        <li class="bullet-point"><strong>Consensual Sexually Explicit Interactions:</strong> Using the Service for sexually driven conversations, explicit sexual solicitations, or cybersex is strictly prohibited, even where both participating users mutually consent to the interaction.</li>
        <li class="bullet-point"><strong>Commercial Sex and Escort Services:</strong> Offering, soliciting, brokering, or advertising commercial sexual services, escorting, prostitution, or paid companionship in any form.</li>
        <li class="bullet-point"><strong>Transactional Relationships:</strong> Engaging in or soliciting any arrangement where money, financial support, gifts, housing, or material compensation is offered or requested in exchange for dates, companionship, or sexual intimacy (including 'sugar dating', 'pay-to-meet', or financial domination arrangements).</li>
      </ul>

      <h3 class="sub-heading">7.5 Aiding, Abetting, and Facilitating Prohibited Conduct</h3>
      <p class="paragraph">The prohibitions in this Acceptable Use Policy extend beyond direct primary offenders. You are strictly forbidden from aiding, abetting, encouraging, assisting, or facilitating any other person in violating this AUP, our Terms of Service, or applicable law. Any individual who assists, enables, conceals, or facilitates prohibited acts—including human trafficking, sexual violence, exploitation, or commercial sex—will face the same immediate enforcement as primary violators, including lifetime account termination and referral to law enforcement.</p>
    </section>

    <section class="section">
      <h2 class="heading">8. SUBSCRIPTION PLANS AND PAYMENTS</h2>

      <h3 class="sub-heading">8.1 Subscription Tiers</h3>
      <p>Adore The Balloon offers the following subscription plans:</p>
      <ul class="bullet-list">
        <li class="bullet-point"><strong>Free:</strong> Basic features with daily limits on swipes, likes, and super likes</li>
        <li class="bullet-point"><strong>Premium:</strong> Enhanced features with increased daily limits and additional perks</li>
        <li class="bullet-point"><strong>VIP:</strong> Full access to all features with maximum daily limits and exclusive benefits</li>
      </ul>

      <h3 class="sub-heading">8.2 Payment Terms</h3>
      <p>By purchasing a subscription:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Payments are processed through Apple App Store or Google Play Store</li>
        <li class="bullet-point">Subscriptions automatically renew unless cancelled at least 24 hours before the renewal date</li>
        <li class="bullet-point">You are responsible for all charges until you cancel your subscription</li>
        <li class="bullet-point">Refunds are subject to Apple App Store and Google Play Store policies</li>
        <li class="bullet-point">We reserve the right to change subscription prices with 30 days' notice</li>
        <li class="bullet-point">All prices are displayed in your local currency</li>
      </ul>

      <h3 class="sub-heading">8.3 Cancellation</h3>
      <p>You may cancel your subscription at any time through your device's app store settings:</p>
      <ul class="bullet-list">
        <li class="bullet-point"><strong>iOS:</strong> Settings &gt; [Your Name] &gt; Subscriptions &gt; Adore The Balloon &gt; Cancel Subscription</li>
        <li class="bullet-point"><strong>Android:</strong> Google Play Store &gt; Subscriptions &gt; Adore The Balloon &gt; Cancel</li>
      </ul>
      <p>Cancellation will take effect at the end of the current billing period. You will continue to have access to premium features until the subscription period ends.</p>

      <h3 class="sub-heading">8.4 Refunds</h3>
      <p>Refund requests must be submitted through Apple App Store or Google Play Store in accordance with their refund policies. We do not provide direct refunds. Refunds are not available for:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Partial subscription periods</li>
        <li class="bullet-point">Unused features or benefits</li>
        <li class="bullet-point">Account termination due to Terms violations</li>
      </ul>
    </section>

    <section class="section">
      <h2 class="heading">9. FEATURES AND SERVICES</h2>

      <h3 class="sub-heading">9.1 Profile Discovery</h3>
      <p>The App allows you to discover other users through:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Swiping on profiles (ignore, pop/like, or super like)</li>
        <li class="bullet-point">Daily limits on swipes, likes, and super likes (varies by subscription tier)</li>
        <li class="bullet-point">Rewind feature to undo previous swipes (limited availability)</li>
        <li class="bullet-point">Location-based matching</li>
        <li class="bullet-point">Preference-based filtering</li>
      </ul>

      <h3 class="sub-heading">9.2 Matching and Communication</h3>
      <p>When you and another user both express interest:</p>
      <ul class="bullet-list">
        <li class="bullet-point">A match is created, enabling chat functionality</li>
        <li class="bullet-point">You can send text messages and images</li>
        <li class="bullet-point">Matches are private and only visible to matched users</li>
        <li class="bullet-point">You can unmatch at any time</li>
        <li class="bullet-point">Blocked users cannot match or message you</li>
      </ul>

      <h3 class="sub-heading">9.3 Dating Lobbies</h3>
      <p>The App offers group dating lobbies where:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Users can join themed group events</li>
        <li class="bullet-point">Participants interact in real-time</li>
        <li class="bullet-point">Matches can be created during lobby activities</li>
        <li class="bullet-point">All lobby interactions must comply with our Zero Tolerance Policy</li>
      </ul>

      <h3 class="sub-heading">9.4 Service Availability</h3>
      <p>We do not guarantee:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Continuous, uninterrupted, or error-free service</li>
        <li class="bullet-point">Specific number of matches or connections</li>
        <li class="bullet-point">Successful relationships or dates</li>
        <li class="bullet-point">Availability of specific features at all times</li>
      </ul>
    </section>

    <section class="section">
      <h2 class="heading">10. INTELLECTUAL PROPERTY RIGHTS</h2>

      <h3 class="sub-heading">10.1 Our Intellectual Property</h3>
      <p>All content, features, and functionality of Adore The Balloon, including but not limited to:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Text, graphics, logos, images, and software</li>
        <li class="bullet-point">App design, layout, and user interface</li>
        <li class="bullet-point">Algorithms, code, and technical processes</li>
        <li class="bullet-point">Trademarks, service marks, and brand names</li>
      </ul>
      <p>Are the exclusive property of Adore The Balloon and its licensors and are protected by copyright, trademark, patent, and other intellectual property laws.</p>

      <h3 class="sub-heading">10.2 Your Content License</h3>
      <p>You retain ownership of content you post on the App. However, by posting content, you grant us a worldwide, royalty-free, perpetual, irrevocable, non-exclusive license to:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Use, display, reproduce, and distribute your content within the App</li>
        <li class="bullet-point">Modify your content as necessary to provide services</li>
        <li class="bullet-point">Use your content for promotional purposes (with your consent)</li>
        <li class="bullet-point">Store and backup your content on our servers</li>
      </ul>

      <h3 class="sub-heading">10.3 User Content Responsibilities</h3>
      <p>You are solely responsible for:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Ensuring you have the right to post your content</li>
        <li class="bullet-point">Obtaining necessary permissions for content featuring others</li>
        <li class="bullet-point">Respecting intellectual property rights of others</li>
        <li class="bullet-point">Not posting copyrighted material without authorization</li>
      </ul>
    </section>

    <section class="section">
      <h2 class="heading">11. PRIVACY AND DATA PROTECTION</h2>

      <h3 class="sub-heading">11.1 Privacy Policy</h3>
      <p>Your use of the App is also governed by our Privacy Policy, which explains how we collect, use, and protect your personal information. By using the App, you consent to our Privacy Policy.</p>

      <h3 class="sub-heading">11.2 Data Security</h3>
      <p>We implement industry-standard security measures to protect your data. However, no method of transmission or storage is 100% secure. You use the App at your own risk.</p>

      <h3 class="sub-heading">11.3 Location Data</h3>
      <p>The App uses your location to provide matching services. You can control location sharing through your device settings, but some features may not work without location access.</p>
    </section>

    <section class="section">
      <h2 class="heading">12. LIMITATION OF LIABILITY</h2>

      <h3 class="sub-heading">12.1 Disclaimer of Warranties</h3>
      <p><strong>TO THE MAXIMUM EXTENT PERMITTED BY LAW:</strong></p>
      <ul class="bullet-list">
        <li class="bullet-point">Adore The Balloon is provided "AS IS" and "AS AVAILABLE" without warranties of any kind, either express or implied</li>
        <li class="bullet-point">We do not guarantee that the App will meet your requirements or expectations</li>
        <li class="bullet-point">We do not guarantee matches, successful relationships, or any specific outcomes</li>
        <li class="bullet-point">We do not warrant that the App will be uninterrupted, secure, or error-free</li>
        <li class="bullet-point">We are not responsible for user interactions, conduct, or content posted by other users</li>
      </ul>

      <h3 class="sub-heading">12.2 Limitation of Liability</h3>
      <p><strong>TO THE MAXIMUM EXTENT PERMITTED BY LAW:</strong></p>
      <ul class="bullet-list">
        <li class="bullet-point">We are not liable for any indirect, incidental, special, consequential, or punitive damages</li>
        <li class="bullet-point">We are not liable for loss of profits, data, goodwill, or other intangible losses</li>
        <li class="bullet-point">We are not responsible for any harm resulting from your use of the App</li>
        <li class="bullet-point">We are not responsible for interactions between users, including dates, relationships, or disputes</li>
        <li class="bullet-point">Our total liability to you for any claims shall not exceed the amount you paid for subscriptions in the past 12 months</li>
      </ul>

      <h3 class="sub-heading">12.3 User Interactions</h3>
      <p><strong>You acknowledge and agree that:</strong></p>
      <ul class="bullet-list">
        <li class="bullet-point">We are not responsible for the conduct of other users</li>
        <li class="bullet-point">We do not screen or verify user information</li>
        <li class="bullet-point">You are solely responsible for your interactions with other users</li>
        <li class="bullet-point">You should exercise caution and good judgment when meeting people in person</li>
        <li class="bullet-point">We are not liable for any harm that occurs during or after in-person meetings</li>
      </ul>
    </section>

    <section class="section">
      <h2 class="heading">13. DISPUTE RESOLUTION</h2>

      <h3 class="sub-heading">13.1 Informal Resolution</h3>
      <p>If you have a dispute with us, you agree to first contact us at support@poptheballoon.com to attempt to resolve the dispute informally.</p>

      <h3 class="sub-heading">13.2 Binding Arbitration</h3>
      <p>If informal resolution fails, any disputes arising from these Terms or your use of the App shall be resolved through binding arbitration in accordance with the rules of [Arbitration Organization], except where prohibited by law.</p>

      <h3 class="sub-heading">13.3 Class Action Waiver</h3>
      <p>You agree that disputes will be resolved individually and not as part of a class action, consolidated action, or representative proceeding.</p>

      <h3 class="sub-heading">13.4 Governing Law</h3>
      <p>These Terms shall be governed by and construed in accordance with the laws of [Your Jurisdiction], without regard to its conflict of law provisions.</p>
    </section>

    <section class="section">
      <h2 class="heading">14. ACCOUNT TERMINATION</h2>

      <h3 class="sub-heading">14.1 Termination by You</h3>
      <p>You may delete your account at any time through the Help & Account Settings section in the App. Account deletion will:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Deactivate your account (soft delete)</li>
        <li class="bullet-point">Remove your profile from discovery</li>
        <li class="bullet-point">Cancel active subscriptions</li>
        <li class="bullet-point">Delete your messages and matches (subject to data retention policies)</li>
        <li class="bullet-point">Some data may be retained for legal or business purposes as required by law</li>
      </ul>

      <h3 class="sub-heading">14.2 Termination by Us</h3>
      <p>We reserve the right to suspend or terminate your account immediately, without prior notice, if you:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Violate these Terms and Conditions or our Zero Tolerance Policy</li>
        <li class="bullet-point">Engage in fraudulent, illegal, or harmful activity</li>
        <li class="bullet-point">Harass, abuse, or harm other users</li>
        <li class="bullet-point">Post objectionable content</li>
        <li class="bullet-point">Fail to pay subscription fees</li>
        <li class="bullet-point">Provide false or misleading information</li>
        <li class="bullet-point">Create multiple accounts</li>
        <li class="bullet-point">Use the App in any way that violates applicable laws</li>
      </ul>

      <h3 class="sub-heading">14.3 Effect of Termination</h3>
      <p>Upon termination:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Your right to use the App immediately ceases</li>
        <li class="bullet-point">You must immediately delete the App from your device</li>
        <li class="bullet-point">We may delete your account, profile, and content</li>
        <li class="bullet-point">You will not receive refunds for unused subscription time</li>
        <li class="bullet-point">Provisions that by their nature should survive termination will remain in effect</li>
      </ul>
    </section>

    <section class="section">
      <h2 class="heading">15. REPORTING AND MODERATION</h2>

      <h3 class="sub-heading">15.1 Reporting System</h3>
      <p>We provide multiple ways to report violations:</p>
      <ul class="bullet-list">
        <li class="bullet-point">In-app reporting feature for objectionable content or abusive behavior</li>
        <li class="bullet-point">Block feature to prevent further contact from specific users</li>
        <li class="bullet-point">Email support at support@poptheballoon.com</li>
        <li class="bullet-point">Emergency contact: [Emergency Contact Information]</li>
      </ul>

      <h3 class="sub-heading">15.2 Our Response</h3>
      <p>We will:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Review all reports promptly and thoroughly</li>
        <li class="bullet-point">Take appropriate action, including warnings, suspensions, or permanent bans</li>
        <li class="bullet-point">Report serious violations to law enforcement when necessary</li>
        <li class="bullet-point">Maintain confidentiality of reports (reported users will not see reporter information)</li>
        <li class="bullet-point">Notify you of actions taken when appropriate</li>
      </ul>

      <h3 class="sub-heading">15.3 False Reports</h3>
      <p>Filing false or malicious reports may result in your account being terminated.</p>
    </section>

    <section class="section">
      <h2 class="heading">16. CHANGES TO TERMS</h2>

      <h3 class="sub-heading">16.1 Right to Modify</h3>
      <p>We reserve the right to modify these Terms at any time. We will notify you of significant changes through:</p>
      <ul class="bullet-list">
        <li class="bullet-point">In-app notifications</li>
        <li class="bullet-point">Email to your registered email address</li>
        <li class="bullet-point">Updates to the "Last Updated" date at the top of this document</li>
      </ul>

      <h3 class="sub-heading">16.2 Acceptance of Changes</h3>
      <p>Continued use of the App after changes to these Terms constitutes your acceptance of the modified Terms. If you do not agree to the modified Terms, you must stop using the App and delete your account.</p>

      <h3 class="sub-heading">16.3 Material Changes</h3>
      <p>For material changes that significantly affect your rights or obligations, we will provide at least 30 days' notice before the changes take effect.</p>
    </section>

    <section class="section">
      <h2 class="heading">17. THIRD-PARTY SERVICES</h2>

      <h3 class="sub-heading">17.1 Third-Party Integrations</h3>
      <p>The App may integrate with third-party services, including:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Payment processors (Apple App Store, Google Play Store)</li>
        <li class="bullet-point">Cloud storage providers</li>
        <li class="bullet-point">Analytics services</li>
        <li class="bullet-point">Social media platforms (optional)</li>
      </ul>

      <h3 class="sub-heading">17.2 Third-Party Terms</h3>
      <p>Your use of third-party services is subject to their respective terms and conditions and privacy policies. We are not responsible for third-party services or their terms.</p>
    </section>

    <section class="section">
      <h2 class="heading">18. CONTACT INFORMATION</h2>

      <h3 class="sub-heading">18.1 Support</h3>
      <p>If you have questions, concerns, or need assistance regarding these Terms and Conditions, please contact us:</p>
      <ul class="bullet-list">
        <li class="bullet-point"><strong>Email:</strong> support@poptheballoon.com</li>
        <li class="bullet-point"><strong>In-App:</strong> Help & Account Settings section</li>
        <li class="bullet-point"><strong>Response Time:</strong> We aim to respond within 48 hours</li>
      </ul>

      <h3 class="sub-heading">18.2 Legal Notices</h3>
      <p>For legal notices or formal complaints, please send written correspondence to:</p>
      <p>
        [Your Company Name]<br>
        [Your Business Address]<br>
        [City, State, ZIP Code]<br>
        [Country]
      </p>
    </section>

    <section class="section">
      <h2 class="heading">19. MISCELLANEOUS PROVISIONS</h2>

      <h3 class="sub-heading">19.1 Entire Agreement</h3>
      <p>These Terms, together with our Privacy Policy, constitute the entire agreement between you and Adore The Balloon regarding your use of the App.</p>

      <h3 class="sub-heading">19.2 Severability</h3>
      <p>If any provision of these Terms is found to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary, and the remaining provisions shall remain in full force and effect.</p>

      <h3 class="sub-heading">19.3 Waiver</h3>
      <p>Our failure to enforce any right or provision of these Terms shall not constitute a waiver of such right or provision.</p>

      <h3 class="sub-heading">19.4 Assignment</h3>
      <p>You may not assign or transfer these Terms or your account without our prior written consent. We may assign these Terms without restriction.</p>

      <h3 class="sub-heading">19.5 Force Majeure</h3>
      <p>We are not liable for any failure to perform our obligations due to circumstances beyond our reasonable control, including natural disasters, war, terrorism, labor disputes, or technical failures.</p>
    </section>

    <section class="section">
      <h2 class="heading">ACKNOWLEDGMENT</h2>

      <p><strong>BY USING Adore The Balloon, YOU ACKNOWLEDGE THAT:</strong></p>

      <ul class="bullet-list">
        <li class="bullet-point"><strong>You have read and understood these Terms of Service, Acceptable Use Policy (AUP), and End User License Agreement (EULA) in their entirety</strong></li>
        <li class="bullet-point"><strong>You agree to be legally bound by these Terms and the Acceptable Use Policy</strong></li>
        <li class="bullet-point"><strong>You understand and accept our Zero Tolerance Policy for objectionable content and abusive users</strong></li>
        <li class="bullet-point"><strong>You will comply with all applicable laws and regulations</strong></li>
        <li class="bullet-point"><strong>You are at least 18 years of age and have the legal capacity to enter into this agreement</strong></li>
        <li class="bullet-point"><strong>You understand that violation of these Terms may result in immediate account termination, legal action, and reporting to law enforcement</strong></li>
        <li class="bullet-point"><strong>You accept that we are not responsible for user interactions, conduct, or outcomes</strong></li>
        <li class="bullet-point"><strong>You use the App at your own risk</strong></li>
      </ul>

      <p><strong>If you do not agree to any of the above, you must immediately stop using the App and delete it from your device.</strong></p>
    </section>

  </div>
</div>
